import Hosts from '../../../Hosts';


const object_type = 'estancia/aula/info'
const object_type2 = 'estancia/aula/info/next'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`
const api_list_order = (companycode) => `${Hosts.SIMCore_API}/${object_type2}/${companycode}/order`

const base_endpoint = '/estancia_aulainfo'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    //view: `${base_endpoint}_view`,
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        name: '',
        category: '',
        observation: '',
        description: '',
        value: {
            tipo: '',       // TIPOS
                            // 0 - Entrada Simples Sem Equipamentos; 
                            // 1 - Entrada Simples Com Equipamentos; 
                            // 2 - Entrada Grupo Sem Equipamentos; 
                            // 3 - Entrada Grupo Com Equipamentos;
                            // 4 - Aula Sem Equipamentos;
                            // 5 - Aula Com Equipamentos;
            dias: '',
            alunos: '',
            equipamentos: false,
            tipologia: '',       // 0 - Adulto | 1 - Criança | 2- Familia 
            price: '0.00',
            taxe: '0.00',
            code_taxe: '00',
            price_s_vat: '0.00',
        },
        detail: {
            tipo: '',       // TIPOS
                            // 0 - Entrada Simples Sem Equipamentos; 
                            // 1 - Entrada Simples Com Equipamentos; 
                            // 2 - Entrada Grupo Sem Equipamentos; 
                            // 3 - Entrada Grupo Com Equipamentos;
                            // 4 - Aula Sem Equipamentos;
                            // 5 - Aula Com Equipamentos;
            dias: '',
            alunos: '',
            equipamentos: false,
            tipologia: '',       // 0 - Adulto | 1 - Criança | 2- Familia  
            price: '0.00',
            taxe: '0.00',
            code_taxe: '00',
            price_s_vat: '0.00',
        },
        media: {
            id: '',
            link: '',
        },  
        type: 'aula',
        order: 0,
        status: true,
        language: []
    }
}

export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route,
    api_list_order,
}